const FAQ_ITEMS = [
  {
    q: '91黑料吃瓜网是什么？',
    a: '91黑料吃瓜网是一个专注于娱乐八卦与黑料事件的实时聚合平台。我们汇集全网最新、最热的娱乐圈黑料，提供91黑料吃瓜在线围观服务，让你第一时间了解明星动态、影视八卦和网红圈层的各类爆料。',
  },
  {
    q: '黑料吃瓜爆料的内容来源可靠吗？',
    a: '我们的内容来自网络公开信息与用户投稿，每条爆料均标注来源。编辑团队会对信息进行交叉核验，但吃瓜需理性——我们鼓励用户在围观娱乐八卦时保持独立判断，黑料吃瓜最新资讯仅供参考。',
  },
  {
    q: '如何第一时间获取最新黑料？',
    a: '你可以收藏本站并开启浏览器通知，也可以关注我们的专题索引和热度榜单。每日滚动更新的快讯时间线确保你不会错过任何一条吃瓜黑料网最新动态。APP下载入口在页面底部。',
  },
  {
    q: '可以投稿爆料吗？',
    a: '当然！我们欢迎瓜友投稿。你可以通过页面上的联系入口提交你掌握的娱乐八卦或黑料事件线索。投稿经核实后会标注来源发布，优质投稿还有机会登上热度榜单。',
  },
  {
    q: '围观吃瓜时需要注意什么？',
    a: '理性吃瓜，文明围观。所有内容仅供娱乐参考，请勿对当事人进行人身攻击或传播未经核实的信息。91黑料吃瓜在线平台倡导健康的围观文化，拒绝网络暴力。',
  },
  {
    q: '如何区分黑料事件的真假？',
    a: '我们会在内容中标注信息来源的可信度等级。官方通报或当事人回应的内容优先展示，网络传言类会明确标注"待核实"。吃瓜黑料网建议用户多方对比信息再做判断。',
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-950">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">
            <i className="ri-question-answer-line text-primary-400 mr-2"></i>
            吃瓜问答
          </h2>
          <p className="mt-2 text-sm text-foreground-500">关于91黑料吃瓜的常见问题，帮你快速了解平台</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {FAQ_ITEMS.map((item, i) => (
            <div
              key={i}
              className="p-5 md:p-6 rounded-xl bg-background-800/40 border border-background-800/60 hover:border-primary-500/20 transition-all duration-200"
            >
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-200 mb-3 flex items-start gap-2">
                <span className="shrink-0 w-6 h-6 flex items-center justify-center rounded-md bg-primary-500/15 text-primary-400 text-xs font-bold mt-0.5">
                  Q
                </span>
                {item.q}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed pl-8">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}